import { Col, Row, Table, Tooltip } from "antd";
import {
  DeleteOutlined,
  UploadOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Button, Modal, Upload } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { DashboardServices, FaqServices } from "../../../redux/Services";
import AbhaLinkedFilter from "../AbhaFilter";
import { DateFormatWithTime } from "../../../utils";
import moment from "moment";
const HipDataRequestReceived = () => {
  const filename = "Data Request Received";
  const [FilteredData, setFilteredData] = useState([]);
  const permission = usePermission("HIP Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [limit, setLimit] = useState(10);
  const totalhipDataRequestLog = useSelector(
    (state) => state.dashboard.totalhipDataRequestLog || []
  );
  const ConsentRequestsLog = useSelector(
    (state) => state.dashboard.hipDataRequestLog || ""
  );
  const { mutate: fetchHIPDataRequestsLog, isLoading } = useMutation(
    (payload) => dispatch(DashboardServices.fetchHIPDataRequestsLogApi(payload))
  );
  const [modal1Open, setModal1Open] = useState(false);
  const [raw, setRaw] = useState({});
  const DataType = {
    sentStatus: -1,
  };
  useEffect(() => {
    console.log("FILTER PAYLOAD SENT TO API:", filter);
    fetchHIPDataRequestsLog({
      DataType,
      DataType2: 10,
      DataType3: 1,
      limit,
      page,
      ...filter,
    });
  }, [filter, limit, page]);

  useEffect(() => {
    if (totalhipDataRequestLog && totalhipDataRequestLog.length > 0) {
      var data = [];
      totalhipDataRequestLog.map((value, index) => {
        var item = {
          sno: value?.sno,
          id: value?.id,
          log_type: value?.log_type,
          requestor: value?.requestor,
          patient_name: value?.patient_name,
          reference_id: value?.reference_id,
          mobile_no: value?.mobile_no,
          heathid_no: value?.heathid_no,
          health_id: value?.health_id,
          createdAt: value?.createdAt,
          updatedAt: value?.updatedAt,
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [totalhipDataRequestLog]);

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Log Id", key: "id" },
    { label: "Log Type", key: "log_type" },
    { label: "Requester (HIU/HIP)", key: "requestor" },
    { label: "Patient Name", key: "patient_name" },
    { label: "Patient Id", key: "reference_id" },
    { label: "Mobile Number", key: "mobile_no" },
    { label: "ABHA Number", key: "heathid_no" },
    { label: "ABHA Address", key: "health_id" },
    { label: "Created At", key: "createdAt" },
    { label: "Updated At", key: "updatedAt" },
  ];

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 100 + index + 1,
    },
    {
      title: "Log Id",
      dataIndex: "id",
      key: "id",
      className: "table_status_col",
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
      className: "table_status_col",
    },
    {
      title: "Request Id",
      dataIndex: "response_request_id",
      key: "response_request_id",
      className: "text-capitalize",
    },

    {
      title: "Requester (HIU/HIP)",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize",
    },
    {
      title: "TransactionId",
      dataIndex: "TransactionId",
      key: "TransactionId",
      className: "table_status_col patient",
      render: (value, item, index) => {
        return (
          <span>
            {" "}
            {JSON.parse(item?.response_raw_data || "{}")?.transactionId}
          </span>
        );
      },
    },
    /* {
            title: 'ABHA Address',
            dataIndex: 'ReferenceId',
            key: 'ReferenceId',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <span>{"amit9119@abdm"}</span>
                )
            }
        },

        {
            title: 'URL',
            dataIndex: 'Status',
            key: 'Status',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <a href='#'>https://www.pathkindlabs.com/abha</a>
                )
            }
        }, */
    {
      title: "From Date Time",
      dataIndex: "FromDate",
      key: "FromDate",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            {DateFormatWithTime(
              JSON.parse(item?.response_raw_data || "{}")?.hiRequest?.dateRange
                ?.from
            )}
          </span>
        );
      },
    },
    {
      title: "To Date Time",
      dataIndex: "ToDate",
      key: "ToDate",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            {DateFormatWithTime(
              JSON.parse(item?.response_raw_data || "{}")?.hiRequest?.dateRange
                ?.to
            )}
          </span>
        );
      },
    },
    {
      title: "Expiry Date Time",
      dataIndex: "expiryDate",
      key: "expiryDate",
      className: "abha-link-date",
      render: (value, item, index) => {
        let expiry = JSON.parse(item?.response_raw_data || "{}")?.hiRequest
          ?.keyMaterial?.dhPublicKey?.expiry;
        return <span>{moment.utc(expiry).format("DD-MM-YYYY H:mm:ss")}</span>;
      },
    },
    {
      title: "Requested Data",
      dataIndex: "Status",
      key: "Status",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <Button
            className="view-btn"
            type="primary"
            onClick={() => {
              setRaw(JSON.parse(item?.response_raw_data || "{}"));
              setModal1Open(true);
            }}
          >
            {" "}
            View
          </Button>
        );
      },
    },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col lg={3} md={24} sm={24} xs={24}>
          <HeadingBack
            title={"Data Request Received"}
            subHeading={`Records ${totalhipDataRequestLog || 0}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            searchHide={true}
            headers={headers}
            FilteredData={ConsentRequestsLog}
            setFilteredData={setFilteredData}
            filename={filename}
          />
        </Col>
        {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey="Id"
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          bordered
          columns={columns}
          dataSource={
            Array.isArray(ConsentRequestsLog) && ConsentRequestsLog?.length > 0
              ? ConsentRequestsLog
              : []
          }
          pagination={{
            current: page,
            pageSize: limit,
            onChange(current, pageSize) {
              setPage(current);
            },
            hideOnSinglePage: true,
            /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
          }}
        />
        <Modal
          style={{
            top: 20,
          }}
          open={modal1Open}
          onOk={() => setModal1Open(false)}
          onCancel={() => setModal1Open(false)}
          footer={null}
        >
          <pre>{JSON.stringify(raw, null, 2)}</pre>
        </Modal>
      </div>
    </div>
  );
};

export default HipDataRequestReceived;
